import {
  GetCurrentUserRolesResponseDto,
  GetUserResponseDto,
} from '@issuemanager/api-client';
import { useMe, useUserPermissions } from '@issuemanager/client/features/users';
import React, {
  PropsWithChildren,
  createContext,
  useContext,
  useMemo,
} from 'react';

const UserContext = createContext<{
  data: GetUserResponseDto | undefined;
  userRoles: GetCurrentUserRolesResponseDto | undefined;
}>({
  data: undefined,
  userRoles: undefined,
});

function UserProvider({ children }: PropsWithChildren): React.JSX.Element {
  const meQuery = useMe();
  const userPermissionsQuery = useUserPermissions();

  const contextValue = useMemo(
    () => ({ data: meQuery.data, userRoles: userPermissionsQuery.data }),
    [meQuery.data, userPermissionsQuery.data],
  );

  return (
    <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
  );
}

const useUserContext = () => useContext(UserContext);

export { UserContext, UserProvider, useUserContext };
